import { useState } from 'react';
import config from '../../utils/apiUrl'; // Adjust the path to your config file

const useTokenEpayco = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getTokenApify = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${config.epayco.apiUrl}/login`, {
        method: 'POST',
        headers: {
          Authorization: `Basic ${btoa(
            `${config.epayco.publicKey}:${config.epayco.privateKey}`
          )}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error('Error en la respuesta de Epayco');
      }

      const result = await response.json();
      if (!result.token) {
        throw new Error(
          'El token no está presente en la respuesta de Epayco'
        );
      }
      return result.token;
    } catch (error) {
      console.error('Error al obtener el token de Epayco:', error.message);
      setError('Error al obtener el token de Epayco');
    } finally {
      setLoading(false);
    }
  };

  return { getTokenApify, loading, error };
};

export default useTokenEpayco;
